import React from 'react'
import PropTypes from "prop-types"
import {FormatUtcDateAsLocal} from '../../../../../../helpers/datetime'
import * as Badges from '../../../../../../components/badges'
import moment from '../../../../../../helpers/moment'

const RestaurantPPETAUpdated = (props) => {
  let data
  let payload = JSON.parse(props.item.payload)
  let formattedDuration = moment.duration(payload.PPETA).format("mm [minutes] s [seconds]")
  data = `Availability set to ${formattedDuration}`

  return <tr>
    <td><Badges.RestaurantPPETAUpdated/></td>
    <td>{data}</td>
    <td>{FormatUtcDateAsLocal(props.item.createdUtc)}</td>
    <td>{props.item.createdBy}</td>
  </tr>
}

RestaurantPPETAUpdated.propTypes = {
  item: PropTypes.object
}

export default RestaurantPPETAUpdated



// WEBPACK FOOTER //
// ./src/containers/restaurants/details/logs/components/restaurantPPETAUpdated/index.js